import * as s from './Modal.css';

export function ModalCloseButton({ onClose }: { readonly onClose: () => void }) {
  return (
    <button type="button" className={s.closeButton} onClick={onClose} aria-label="닫기">
      [ESC]
    </button>
  );
}
